import { debug } from "../config";

export const getParam = (name) => {
  const searchParams = new URLSearchParams(document.location.search);
  return searchParams.get(name);
};

export const getIsEmbedded = () => {
  return "isEmbedded" in debug ? debug.isEmbedded : getParam("embedded");
};

export const getUrlQueryParam = () => {
  return "url" in debug ? debug.url : getParam("url");
};

export const getShowTutorialButton = () => {
  if (!getIsEmbedded()) {
    return true;
  }
  return getParam("showTutorial") ?? false;
};
